const budget_accounts = [
    {
        account_id: "RWKAQBXBLlTn3QjK8GZ6CejzyDW1o7TRqNyjr",
        balances: {available: 100, current: 110, iso_currency_code: "USD", limit: null, unofficial_currency_code: null},
        mask: "0000",
        name: "Plaid Checking",
        official_name: "Plaid Gold Standard 0% Interest Checking",
        subtype: "checking",
        type: "depository",
    },
    {
        account_id: "6Rq4eXNXMkiMLBEbXy1PU97xaPAJdeFglQZJE",
        balances: {available: 200, current: 210, iso_currency_code: "USD", limit: null, unofficial_currency_code: null},
        mask: "1111",
        name: "Plaid Saving",
        official_name: "Plaid Silver Standard 0.1% Interest Saving",
        subtype: "savings",
        type: "depository",
    },
    {
        account_id: "XydRgoEol3TaNbDAVK3dUGg4mzNlEwudXkZgw",
        balances: {available: null, current: 1000, iso_currency_code: "USD", limit: null, unofficial_currency_code: null},
        mask: "2222",
        name: "Plaid CD",
        official_name: "Plaid Bronze Standard 0.2% Interest CD",
        subtype: "cd",
        type: "depository",
    },
    {
        account_id: "DPeG1ojo3EioZEzWXaAxU5e6mMBpRlSvoNDej",
        balances: {available: null, current: 410, iso_currency_code: "USD", limit: 2000, unofficial_currency_code: null},
        mask: "3333",
        name: "Plaid Credit Card",
        official_name: "Plaid Diamond 12.5% APR Interest Credit Card",
        subtype: "credit card",
        type: "credit",
    },
    {
        account_id: "Vb3mapGp8zt3GyVAwNZjUDkn6ebAvMiWVQ1k7",
        balances: {available: 43200, current: 43200, iso_currency_code: "USD", limit: null, unofficial_currency_code: null},
        mask: "4444",
        name: "Plaid Money Market",
        official_name: "Plaid Platinum Standard 1.85% Interest Money Market",
        subtype: "money market",
    },
    {
        account_id: "wWP1b393B6TnLGJox63gCwbx1z6WAnUrpzwwW",
        balances: {available: null, current: 320.76, iso_currency_code: "USD", limit: null, unofficial_currency_code: null},
        mask: "5555",
        name: "Plaid IRA",
        official_name: null,
        subtype: "ira",
        type: "investment",
    },
    {
        account_id: "5vla47G7ZXfBeRD7J19lH3dea1my4BUZnXllR",
        balances: {available: null, current: 23631.9805, iso_currency_code: "USD", limit: null, unofficial_currency_code: null},
        mask: "6666",
        name: "Plaid 401k",
        official_name: null,
        subtype: "401k",
        type: "investment",
    },
    {
        account_id: "JMpW4kRkPyI7nDKP8RbxUvjrVPBNE3tdyX33m",
        balances: {available: null, current: 65262, iso_currency_code: "USD", limit: null, unofficial_currency_code: null},
        mask: "7777",
        name: "Plaid Student Loan",
        official_name: null,
        subtype: "student",
        type: "loan",
    }
]

const budget_transactions = [
    {
        account_id: "RWKAQBXBLlTn3QjK8GZ6CejzyDW1o7TRqNyjr",
        account_owner: null,
        amount: 6.33,
        authorized_date: null,
        category: ["Travel", "Taxi"],
        category_id: "22016000",
        date: "2020-01-29",
        iso_currency_code: "USD",
        location: {address: null, city: null, country: null, lat: null, lon: null, postal_code: null, region: null, store_number: null},
        name: "Uber",
        payment_channel: "in store",
        payment_meta: {by_order_of: null, payee: null, payer: null, payment_method: null, payment_processor: null},
        pending: false,
        pending_transaction_id: null,
        transaction_id: "8lrPD6V6Lof74w1JZQPeU1J68DAMEKtwX1yMV",
        transaction_type: "special",
        unofficial_currency_code: null
    },
    {
        account_id: "DPeG1ojo3EioZEzWXaAxU5e6mMBpRlSvoNDej",
        account_owner: null,
        amount: 500,
        authorized_date: null,
        category: ["Food and Drink", "Restaurants"],
        category_id: "13005000",
        date: "2020-01-26",
        iso_currency_code: "USD",
        location: {address: null, city: null, country: null, lat: null, lon: null, postal_code: null, region: null, store_number: null},
        name: "Tectra Inc",
        payment_channel: "in store",
        payment_meta: {by_order_of: null, payee: null, payer: null, payment_method: null, payment_processor: null},
        pending: false,
        pending_transaction_id: null,
        transaction_id: "9qzjdkNkpohxVNb7REZnCGyDagLj9PIRvGmAN",
        transaction_type: "place",
        unofficial_currency_code: null
    },
    {
        account_id: "DPeG1ojo3EioZEzWXaAxU5e6mMBpRlSvoNDej",
        account_owner: null,
        amount: 2078.5,
        authorized_date: null,
        category: ["Payment"],
        category_id: "16000000",
        date: "2020-01-25",
        iso_currency_code: "USD",
        location: {address: null, city: null, country: null, lat: null, lon: null, postal_code: null, region: null, store_number: null},
        name: "AUTOMATIC PAYMENT - THANK",
        payment_channel: "other",
        payment_meta: {by_order_of: null, payee: null, payer: null, payment_method: null, payment_processor: null},
        pending: false,
        pending_transaction_id: null,
        transaction_id: "6Rq4eXNXMkiMLBEbXy1PU97xKJWLBzTgl9RNo",
        transaction_type: "special",
        unofficial_currency_code: null,
    },
    {
        account_id: "DPeG1ojo3EioZEzWXaAxU5e6mMBpRlSvoNDej",
        account_owner: null,
        amount: 500,
        authorized_date: null,
        category: ["Food and Drink", "Restaurants", "Fast Food"],
        category_id: "13005032",
        date: "2020-01-25",
        iso_currency_code: "USD",
        location: {address: null, city: null, country: null, lat: null, lon: null, postal_code: null, region: null, store_number: null},
        name: "KFC",
        payment_channel: "in store",
        payment_meta: {by_order_of: null, payee: null, payer: null, payment_method: null, payment_processor: null},
        pending: false,
        pending_transaction_id: null,
        transaction_id: "RWKAQBXBLlTn3QjK8GZ6CejzP1Np6kFRqlQDQ",
        transaction_type: "place",
        unofficial_currency_code: null
    },
    {
        account_id: "DPeG1ojo3EioZEzWXaAxU5e6mMBpRlSvoNDej",
        account_owner: null,
        amount: 500,
        authorized_date: null,
        category: ["Shops", "Sporting Goods"],
        category_id: "19046000",
        date: "2020-01-25",
        iso_currency_code: "USD",
        location: {address: null, city: null, country: null, lat: null, lon: null, postal_code: null, region: null, store_number: null},
        name: "Madison Bicycle Shop",
        payment_channel: "in store",
        payment_meta: {by_order_of: null, payee: null, payer: null, payment_method: null, payment_processor: null},
        pending: false,
        pending_transaction_id: null,
        transaction_id: "vENJMB9Bz6tGNEM1AD3XsVMXPrxGK4uWKzDNM",
        transaction_type: "place",
        unofficial_currency_code: null
    },
    {
        account_id: "6Rq4eXNXMkiMLBEbXy1PU97xaPAJdeFglQZJE",
        account_owner: null,
        amount: 25,
        authorized_date: null,
        category: ["Payment", "Credit Card"],
        category_id: "16001000",
        date: "2020-01-16",
        iso_currency_code: "USD",
        location: {address: null, city: null, country: null, lat: null, lon: null, postal_code: null, region: null, store_number: null},
        name: "CREDIT CARD 3333 PAYMENT *//",
        payment_channel: "other",
        payment_meta: {by_order_of: null, payee: null, payer: null, payment_method: null, payment_processor: null},
        pending: false,
        pending_transaction_id: null,
        transaction_id: "bBMo6pQp4RudnGNEWM83cjZBoAK7P9uVkxwan",
        transaction_type: "special",
        unofficial_currency_code: null
    }
]
const Budget = {
    accounts: budget_accounts,
    transactions: budget_transactions
}

export default { Budget }